import React from 'react';
import { t } from '../utils/i18n';

export default function ObservationStatus({ reason, lastReadAt, onResume, disabled }) {
  return <div className="flex flex-wrap items-center gap-3 px-4 py-2 text-xs text-dark-text-secondary" role="status">
    <span>{t(reason ? 'observation.stopped' : 'observation.active')}{reason ? ` · ${t(`observation.${reason}`)}` : ''}</span>
    {lastReadAt && <span>{t('observation.lastRead')}: {new Date(lastReadAt).toLocaleTimeString()}</span>}
    <button type="button" disabled={disabled} onClick={onResume} className="rounded border border-dark-border px-2 py-1 disabled:opacity-40">{t('observation.resume')}</button>
  </div>;
}
